"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var DateList_1 = __importDefault(require("~/components/users/estimates/requests/messages/reserve_date_modal/DateList"));
var SelectDateForm_1 = __importDefault(require("~/components/users/estimates/requests/messages/reserve_date_modal/SelectDateForm"));
var MODAL_WIDTH_MAX = 600;
var ReserveDateModal = function (_a) {
    var isModalOpen = _a.isModalOpen, onClose = _a.onClose, reservationDates = _a.reservationDates, onClickSubmitButton = _a.onClickSubmitButton, onClickConfirmDateButton = _a.onClickConfirmDateButton;
    var modalWidth = Math.min(window.innerWidth * 0.9, MODAL_WIDTH_MAX);
    var _b = react_1.default.useState(0), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var _c = react_1.default.useState(), selectedDate = _c[0], setSelectedDate = _c[1];
    var _d = react_1.default.useState(0), wrapperLeftPosition = _d[0], setWrapperLeftPosition = _d[1];
    var handleClose = function () {
        setWrapperLeftPosition(0);
        onClose();
    };
    var handleClickCalendarButton = function (index, rDate) {
        setSelectedIndex(index);
        setSelectedDate(rDate);
        setWrapperLeftPosition(-modalWidth);
    };
    var handleClickConfirmButton = function (date) {
        setWrapperLeftPosition(0);
        onClickConfirmDateButton(selectedIndex, date);
    };
    return (react_1.default.createElement(react_responsive_modal_1.default, { onClose: handleClose, open: isModalOpen, styles: { modal: { width: modalWidth } }, classNames: { modal: "usersEstimatesRequestsMessages-ReservationDateModal" } },
        react_1.default.createElement("div", { style: { width: modalWidth * 2, left: wrapperLeftPosition }, className: "usersEstimatesRequestsMessages-ReservationDateModal_InnerBoxWrapper" },
            react_1.default.createElement("div", { style: { width: modalWidth }, className: "usersEstimatesRequestsMessages-ReservationDateModal_InnerBox" },
                react_1.default.createElement(DateList_1.default, { reservationDates: reservationDates, onClickCalendarButton: handleClickCalendarButton, onClickSubmitButton: onClickSubmitButton })),
            react_1.default.createElement("div", { style: { width: modalWidth }, className: "usersEstimatesRequestsMessages-ReservationDateModal_InnerBox" },
                react_1.default.createElement(SelectDateForm_1.default, { priority: selectedIndex + 1, selectedDate: selectedDate, selectedReservedDates: reservationDates, onClickConfirm: handleClickConfirmButton })))));
};
exports.default = ReserveDateModal;
